import { LOCAL_STORAGE_NEWSBOARD_POST_FILE_DELETE_CONFIRMATION_DISABLED_KEY } from '../../../constants/storage'
import { getStorageItem } from '../../../utils/storage'

export function isNewsboardPostFileDeleteConfirmationDisabled() {
  return (
    getStorageItem(
      LOCAL_STORAGE_NEWSBOARD_POST_FILE_DELETE_CONFIRMATION_DISABLED_KEY
    ) === 'true'
  )
}
